import { diaryByIdQueryOptions } from "@/features/diaries/api";
import DiarySkeleton from "@/features/patients/components/DiarySkeleton";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { validate } from "uuid";

const PatientDiaryPage = () => {
	return (
		<Suspense fallback={<DiarySkeleton />}>
			<Outlet />
		</Suspense>
	);
};

export const Route = createFileRoute("/_app/patients/$diaryId")({
	component: PatientDiaryPage,
	loader: async ({ context, params }) => {
		if (!context?.queryClient) {
			throw new Error("Query client not available");
		}

		const diaryId = params.diaryId;
		if (!diaryId || !validate(diaryId)) {
			return { diary: null };
		}

		await context.queryClient.ensureQueryData(diaryByIdQueryOptions(diaryId));
	},
});
